import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.trim.js";
var topicParams = {
  'filter[hot]': 1,
  'filter[content]': ''
};
import { topicList, topicCreate, uploadImg, post } from '@/api/mg';
export default {
  data: function data() {
    return {
      type: '1',
      title: '',
      value1: '1',
      isGetResault: false,
      isEmpty: true,
      value: '',
      isInput: false,
      isShowPop: false,
      message: '',
      searchTopicList: [],
      hotTopicList: [],
      selectTopicList: [],
      imgArr: [],
      fileList: [],
      pid: ''
    };
  },
  created: function created() {
    this.value = '';
    this.pid = localStorage.getItem('pid');
    topicParams['filter[content]'] = '';
    topicParams['perPage'] = 10;
    topicParams['page'] = 1;
    this.getTopicList(topicParams);
  },
  methods: {
    close: function close(topicId) {
      var _this = this;
      this.selectTopicList.forEach(function (item, index) {
        if (Object.values(item)[0] === topicId) {
          _this.selectTopicList.splice(index, 1);
        }
      });
    },
    fileChange: function fileChange() {
      console.log(this.type);
      this.fileList = [];
    },
    cateoryChange: function cateoryChange(val) {
      this.title = '';
      this.selectTopicList = [];
    },
    onOversize: function onOversize() {
      this.$toast('文件过大');
    },
    del: function del(file) {
      console.log(this.fileList, 'this.fileList');
    },
    afterRead: function afterRead(file) {
      var _this2 = this;
      // 此时可以自行将文件上传至服务器
      if (file instanceof Array) {
        // 判断是否是数组
        file.map(function (item) {
          var formData = new FormData();
          formData.append('file', item.file);
          formData.append('type', _this2.type);
          item.status = 'uploading';
          item.message = 'uploading...';
          uploadImg(formData).then(function (res) {
            if (res.Code === 0) {
              item.id = res.Data.id;
              item.status = 'done';
              item.message = 'success';
            } else {
              item.status = 'failed';
              item.message = 'failed';
            }
          }).catch(function () {
            item.status = 'failed';
            item.message = 'failed';
          });
        });
      } else {
        var formData = new FormData();
        formData.append('file', file.file);
        formData.append('type', this.type);
        file.status = 'uploading';
        file.message = 'uploading...';
        uploadImg(formData).then(function (res) {
          if (res.Code === 0) {
            file.id = res.Data.id;
            console.log(_this2.fileList, 'this.fileList');
            file.status = 'done';
            file.message = 'success';
          } else {
            file.status = 'failed';
            file.message = 'failed';
          }
        }).catch(function () {
          file.status = 'failed';
          file.message = 'failed';
        });
      }
      // this.fileList.forEach((item) => {
      // const params = { type: 1, file: file.file }
      // uploadImg(formData).then((res) => {
      //   if (res.Code === 0) {
      //     console.log(res.Data)
      //     console.log(this.fileList, 'this.fileList')
      //   } else {
      //     this.$toast(res.Message)
      //   }
      // })
      // })
    },
    getTopicList: function getTopicList(params, type) {
      var _this3 = this;
      topicList(params).then(function (res) {
        if (res.Code === 0) {
          if (type === 'search') {
            _this3.searchTopicList = res.Data.pageData;
            if (_this3.searchTopicList.length === 0) {
              _this3.isGetResault = true;
            } else {
              _this3.isGetResault = false;
            }
            return;
          }
          _this3.hotTopicList = res.Data.pageData;
        } else {
          _this3.$toast(res.Message);
        }
      });
    },
    getTopic: function getTopic(topicId, topic) {
      console.log(topicId, topic, 'topicId,topic');
      var obj = {
        topicId: topicId,
        topic: topic
      };
      var flag = true;
      this.selectTopicList.forEach(function (item) {
        console.log(Object.values(item));
        if (Object.values(item)[0] === topicId) {
          flag = false;
        }
      });
      if (flag) {
        this.selectTopicList.push(obj);
      } else {
        this.$toast('topic already exist');
        return;
      }
      this.value = '';
      this.isInput = false;
      this.isShowPop = false;
      this.isEmpty = true;
      this.value = '';
      this.isInput = false;
    },
    createTopic: function createTopic() {
      var _this4 = this;
      var params = {
        topic_name: this.value
      };
      topicCreate(params).then(function (res) {
        if (res.Code === 0) {
          var data = res.Data;
          var obj = {
            topicId: data.topic_id,
            topic: data.content
          };
          _this4.selectTopicList.push(obj);
        } else {
          _this4.$toast(res.Message);
        }
      });
      this.isShowPop = false;
      this.isEmpty = true;
      this.value = '';
      this.isInput = false;
    },
    // getResult(value) {
    // },
    clear: function clear() {
      this.value = '';
      this.isInput = false;
      this.isResults = false;
      this.isEmpty = true;
    },
    input: function input() {
      if (this.value.trim()) {
        this.isGetResault = false;
        this.isInput = true;
        this.isEmpty = false;
        topicParams['filter[content]'] = this.value;
        topicParams['perPage'] = '';
        topicParams['page'] = '';
        this.getTopicList(topicParams, 'search');
      } else {
        this.isInput = false;
        this.isEmpty = true;
      }
    },
    closePop: function closePop() {
      this.isShowPop = false;
      this.value = '';
      this.isInput = false;
      this.isEmpty = true;
    },
    topicSearch: function topicSearch() {
      this.isShowPop = true;
    },
    publish: function publish() {
      var _this5 = this;
      if (this.pid === '1' && this.value1 === '4') {
        console.log(this.fileList, this.message, 'this.fileList,this.message');
        if (this.title.trim() === '') {
          this.$toast('Incomplete information');
          return;
        } else if (this.fileList.length === 0 && this.message.trim() === '') {
          this.$toast('Incomplete information');
          return;
        }
      }
      if (this.fileList.length === 0 && this.message.trim() === '') {
        this.$toast('Incomplete information');
        return;
      }
      var arr1 = [];
      this.selectTopicList.forEach(function (item) {
        arr1.push(item.topicId);
      });
      var arr = [];
      this.fileList.forEach(function (item) {
        arr.push(item.id);
      });
      // const params = { categoryId: 1, 'content[indexes][101][body][imageIds]': arr, 'content[indexes][101][tomId]': 101, 'content[text]': this.message }
      var params = {
        topic_ids: arr1,
        categoryId: this.value1,
        title: this.title,
        content: {
          text: this.message,
          indexes: {
            101: {
              tomId: 101,
              body: {
                imageIds: arr
              }
            }
          }
        }
      };
      params.token = JSON.parse(localStorage.getItem('appParams')).token;
      post(params).then(function (res) {
        if (res.Code === 0) {
          _this5.$router.back();
        } else {
          _this5.$toast(res.Message);
        }
      });
      this.$toast('调取发表接口');
    },
    back: function back() {
      var _this6 = this;
      var timer = setTimeout(function () {
        _this6.$router.back();
        clearTimeout(timer);
      }, 100);
    }
  }
};